/** @format */

import React, { type Ref } from 'react'
import LoginBackground from '../../assets/icons/loginBackground.jpg'
import type { CompoundFC } from '@/shared/lib/compound'

const cx = (...classes: (string | boolean | undefined | null)[]) => classes.filter(Boolean).join(' ')

const LoginContainer: CompoundFC = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-full flex mx-auto', className)}
    style={{
      backgroundColor: 'var(--background)',
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
LoginContainer.displayName = 'LoginContainer'

const LoginContainerBox = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'min-h-[500px] flex w-full h-screen',
      'max-[1200px]:gap-[100px] max-[1024px]:gap-[50px] max-[768px]:gap-5 max-[768px]:flex-col max-[768px]:items-center',
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </div>
)
LoginContainerBox.displayName = 'LoginContainerBox'
LoginContainer.Box = LoginContainerBox

const LoginContainerBoxLeft = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-[40%] flex flex-col items-center justify-center', className)}
    style={style}
    {...props}
  >
    {children}
  </div>
)
LoginContainerBoxLeft.displayName = 'LoginContainerBoxLeft'
LoginContainer.BoxLeft = LoginContainerBoxLeft

const LoginContainerBoxRight = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-[60%] bg-cover bg-center bg-no-repeat', className)}
    style={{
      backgroundImage: `url(${LoginBackground})`,
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
LoginContainerBoxRight.displayName = 'LoginContainerBoxRight'
LoginContainer.BoxRight = LoginContainerBoxRight

export { LoginContainer }
